import React, { useEffect, useState } from 'react';
import { ZoomMtg } from '@zoom/meetingsdk';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
function MeetingRoom() {
  const location = useLocation();
  const { signature } = useParams();
  const navigate = useNavigate();

  const joinmeeting = async () => {
    try {
      const params = new URLSearchParams(location.search);
      const meetingId = params.get('meetingId');
      const disputeId = params.get('disputeId');

      const leaveUrl = `${window.location.origin}/leave-room/${disputeId}`;
      ZoomMtg.preLoadWasm();
      ZoomMtg.prepareWebSDK();
      // @ts-expect-error
      document.getElementById('zmmtg-root').style.display = 'block';
      ZoomMtg.init({
        leaveUrl: leaveUrl,
        patchJsMedia: true,
        leaveOnPageUnload: true,
        debug: true,
        success: (success: unknown) => {
          console.log(success);
          // can this be async?
          ZoomMtg.join({
            signature: signature as string,
            sdkKey: 'Hf0rYHvDRUmdR7YIxvIGAg',
            meetingNumber: meetingId as string,
            passWord: '123456',
            userName: 'Yad Admin',
            userEmail: 'admin@yad.com',

            success: (success: unknown) => {
              console.log(success);
            },
            error: (error: unknown) => {
              console.log('error test from running');
              console.log(error);
            },
          });
        },
        error: (error: unknown) => {
          console.log('error test from init');
          console.log(error);
          navigate('/');
        },
      });
    } catch (err) {
      console.log(err);
      navigate('/');
    }
  };

  useEffect(() => {
    if (location) joinmeeting?.();
  }, [location]);

  return <div className="hidden" id="zmmtg-root"></div>;
}
export default MeetingRoom;
